module.exports = __webpack_public_path__ + "img/D - 02.54a34f8b.png";